import { widgetStore } from '../stores';

export const POST_MESSAGE_KEYS = {
  RESIZE_WIDGET: 'yacht:resize-widget',
  REDIRECT: 'yacht:redirect',
  INITIALIZED: 'yacht:initialized',
  ANALYTICS_CALENDAR_RENDER: 'yacht:analytics:calendar-render',
  ANALYTICS_PRICE_CHECK: 'yacht:analytics:price-check',
  ANALYTICS_SEND_QUESTION: 'yacht:analytics:send-question',
  ANALYTICS_BOOKING_CREATE: 'yacht:analytics:booking-create',
};

export const sendData = payload => {
  try {
    const { parent } = window;
    parent.postMessage(JSON.stringify(payload), '*');
  } catch (error) {
    console.warn(error); // eslint-disable-line
  }
};

export const sendAnalyticsData = payload => {
  try {
    if (widgetStore.analyticsEnabled) {
      const { parent } = window;
      parent.postMessage(JSON.stringify(payload), '*');
    }
  } catch (error) {
    console.warn(error); // eslint-disable-line
  }
};

export const iSJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
